// extracted by mini-css-extract-plugin
module.exports = {"checkbox-container":"checkbox_checkbox-container__1yMl8","icon":"checkbox_icon__2u9lf","children":"checkbox_children__1vo4O"};